import { useDispatch, useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import { apiClient } from '../../utils/axios';
import { printPdf } from '../../helper/PrintPdf';
import { showSnackbar } from '../../api/snackbarSlice';

const documentlActions = {
  '01': 'invoices',
  11: 'invoices',
  '02': 'credit-notes',
  12: 'credit-notes',
  '03': 'debit-notes',
  13: 'debit-notes',
  '04': 'refunds',
  14: 'refunds',
};

export const usePdfActions = () => {
  const dispatch = useDispatch();
  const pdfTemplates = useSelector((state) => state.pdfTemplates.pdfTemplates);

  const downloadPdf = async (documentType, documentContent, documentId) => {
    const docType = documentlActions[documentType];
    dispatch(showSnackbar({ message: 'Downloading document...', severity: 'info' }));

    try {
      const template = pdfTemplates.find((t) => t.document_type === docType);

      if (!template) {
        dispatch(showSnackbar({ message: `${docType} template not found`, severity: 'error' }));
        return false;
      }

      const response = await apiClient.get(`/${docType.toLowerCase()}/${documentId}/download-pdf`, {
        params: { template_name: template.name, is_receipt: false },
        responseType: 'blob',
      });

      saveAs(response.data, response.headers.get('x-suggested-filename'));
      dispatch(showSnackbar({ message: 'Document downloaded successfully!', severity: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to download document', severity: 'error' }));
      console.error(error);
    }
  };

  const handlePrintPdf = async (documentType, documentContent, documentId) => {
    const docType = documentlActions[documentType];
    dispatch(showSnackbar({ message: 'Printing document...', severity: 'info' }));

    try {
      const template = pdfTemplates.find((t) => t.document_type === docType);

      if (!template) {
        dispatch(showSnackbar({ message: `${docType} template not found`, severity: 'error' }));
        return false;
      }

      await printPdf(docType, documentId, template, false);
      dispatch(showSnackbar({ message: 'Document printed successfully!', severity: 'success' }));
      return true;
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to print document', severity: 'error' }));
      console.error(error);
      return false;
    }
  };

  return { downloadPdf, handlePrintPdf };
};
